<template>
  <v-dialog v-model="dialogLocal" width="500px">
    <v-card>
      <v-card-title>{{ lang.add_user }}</v-card-title>
      <v-divider class="ma-0"></v-divider>
      <v-container grid-list-sm class="pa-4 add-user-dialog">
        <v-row>
          <v-col>
            <v-form :v-model="true" ref="form" lazy-validation>
              <v-text-field
                :rules="nameRules"
                :label="lang.account_name"
                v-model="addingAccountName"
                class="input-group--focused"
                prepend-icon="fa-light fa-building"
              ></v-text-field>
              <v-text-field
                prepend-icon="fa-light fa-envelope"
                v-model="addingEmail"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
              <v-text-field
                :rules="nameRules"
                :label="lang.user_name"
                v-model="addingName"
                class="input-group--focused"
                prepend-icon="fa-light fa-user-tag"
              ></v-text-field>
              <v-text-field
                v-model="addingPassword"
                prepend-icon="fa-light fa-lock"
                :append-icon="!showPass ? 'mdi-eye' : 'mdi-content-copy'"
                :rules="passRules"
                :type="showPass ? 'text' : 'password'"
                name="input-10-2"
                :label="lang.password"
                @click:append="showPassword()"
              ></v-text-field>
              <v-btn block text color="secondary" @click="passGenerator">{{
                lang.generate_password
              }}</v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="ma-0"></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="secondary" @click="dialogLocal = false">{{
          lang.cancel
        }}</v-btn>
        <v-btn text color="primary" @click="addUser">{{ lang.add_user }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
const users = require("./users.js").users;
const passGenerator = require("generate-password");

export default {
  data() {
    return {
      addingEmail: "",
      addingName: "",
      addingAccountName: "",
      showPass: false,
      addingPassword: "",

      passRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 6) || "Min 6 characters",
      ],
      nameRules: [
        (v) => !!v || this.lang.name_required,
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  components: {},
  props: {
    dialog: Boolean,
  },
  watch: {
    dialog: function(val) {
      if (!val) return;
      this.addingPassword = "";
      this.addingEmail = "";
      this.addingName = "";
      this.addingAccountName = "";
    },
  },
  computed: {
    ...mapState(["lang"]),
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },
  mounted() {},
  methods: {
    showPassword() {
      if (this.showPass) this.copyPassword();
      this.showPass = true;
    },
    copyPassword() {
      navigator.clipboard.writeText(this.addingPassword).then(
        function() {},
        function(err) {}
      );
    },
    passGenerator() {
      this.addingPassword = passGenerator.generate({
        length: 10,
        numbers: true,
        excludeSimilarCharacters: true,
      });
      this.showPass = true;
    },
    addUser() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.dialogLocal = false;
      users.add(
        this.addingEmail,
        this.addingName,
        this.addingPassword,
        this.addingAccountName
      );
    },
  },
};
</script>

<style>
.add-user-dialog .v-input__prepend-outer {
  margin-right: 20px;
}
</style>
